import {Component, OnInit, ViewChild} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { DateUtilsService } from './../../services/date-utils.service';
import { AuthService } from './../../services/auth.service';
import { UserService } from './../../services/user.service';
import { LoadingController, Platform } from '@ionic/angular';
import { FormBuilder } from "@angular/forms";
import { Router } from '@angular/router';
import { AlertController, IonModal } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';
import { Badge } from '@capawesome/capacitor-badge';
import { User } from './../../models/user';
import { environment } from './../../../environments/environment';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  standalone: true,
  imports: [IonicModule, TranslateModule, CommonModule],
})
export class NotificationComponent  implements OnInit {
  @ViewChild('modalNotifications', { static: false }) modalNotifications!: IonModal;

  user: User | null = null;
  initial: string | null | undefined = null;
  notifNbNotRead: number = 0
  notifications: { [key: string]: any }[] = []

  constructor(
    private http: HttpClient,
    public dateUtils: DateUtilsService,
    public authService: AuthService,
    public userService: UserService,
    private router: Router,
    public fb: FormBuilder,
    public platform: Platform,
    public loadingController: LoadingController,
    public alertController: AlertController,) {
    this.authService.loginStatus$.subscribe(async (isLoggedIn) => {
      this.updateLoginStatus(isLoggedIn);
    });
    this.authService.notificationsUpdate$.subscribe(async (n) => {
      this.notifNbNotRead = 0;
      this.notifications = this.authService.notifications
      for(var notif in this.notifications) {
        if(!this.notifications[notif]['isRead'])
          this.notifNbNotRead += 1
      }

      //Mise à jour du badge
      if (Capacitor.getPlatform() !== 'web')
        await Badge.set({ count: this.notifNbNotRead });
    });

    this.platform.resume.subscribe(async () => {
      this.authService.getIsLoggedIn().then(data => {
        if(!this.authService.isLoggedIn) {
          this.updateNotifications();
        }
      });
    });

    this.authService.getIsLoggedIn().then(data => {
      this.updateLoginStatus(this.authService.isLoggedIn);
    });
  }

  ngOnInit() {
  }

  updateLoginStatus(isLoggedIn: boolean) {
    if(isLoggedIn) {
      this.initial = this.userService.user?.getInitial();
      this.user = this.userService.user;
    } else {
      this.initial= null;
      this.user = null;
    }
  }

  async notifOpenCB(notif: { [key: string]: any }) {
    let split = notif['url'].split('#')
    this.router.navigate([split['0']], { fragment: split['1']});
    this.modalNotifications.dismiss();

    if(notif['isRead']) {
      this.notifNbNotRead -= 1;
      if (Capacitor.getPlatform() !== 'web')
        await Badge.set({ count: this.notifNbNotRead });
    }
    notif['isRead'] = true

    let formData = {};
    var headers = new HttpHeaders({
      'Authorization': this.userService.getHttpHeaders(),
      'content-type': 'application/json'
    });
    this.http.post(environment.API_URL + 'userProfile/ws_private/' + notif['id'] + '/notifRead/', JSON.stringify(formData), {headers : headers}).subscribe((response) => {
    }); 
  }

  updateNotifications() {
    if(!this.userService.getHttpHeaders())
      return
    var headers = new HttpHeaders({
      'Authorization': this.userService.getHttpHeaders()
    });
    this.http.get(environment.API_URL + 'userProfile/ws_private/GetNotifications/', {headers : headers}).subscribe((response) => {
    }); 
  }

  async markAllAsReadCB() {
    this.modalNotifications.dismiss();

    for(var notif in this.notifications) {
      this.notifications[notif]['isRead'] = true
    }
    this.notifNbNotRead = 0;
    if (Capacitor.getPlatform() !== 'web')
      await Badge.set({ count: this.notifNbNotRead });

    let formData = {};
    var headers = new HttpHeaders({
      'Authorization': this.userService.getHttpHeaders(),
      'content-type': 'application/json'
    });
    this.http.post(environment.API_URL + 'userProfile/ws_private/notifAllRead/', JSON.stringify(formData), {headers : headers}).subscribe((response) => {
    }); 
  }

}
